// #130 Sipariş Detay paneli (tahta altı) — seçili sipariş için
// GET /api/shipmentplans/order-detail?orderId= ile başlık + kalem tablosu +
// toplamlar, E-Belge rozeti ve Fat./İrs. seçici gösterir.
import { useEffect, useState } from 'react';
import { authHeaders } from '../listPageStyles';
import { EDocBadge, DocTypeChip } from './OrderCard';
import { API_BASE, unwrap, fmtMoney, fmtNumber } from './shipmentPlanningUtils';

export default function OrderDetailPanel({ order, onDocTypeChange }) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!order) { setDetail(null); return undefined; }
    let alive = true;
    setLoading(true); setError(null);
    fetch(`${API_BASE}/order-detail?orderId=${encodeURIComponent(order.orderId)}`, { headers: authHeaders() })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => { if (alive) setDetail(unwrap(d)); })
      .catch(() => { if (alive) setError('Sipariş detayı alınamadı.'); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [order]);

  if (!order) {
    return (
      <div style={wrap}>
        <Head title="Sipariş Detay" />
        <div style={{ padding: 20, color: 'var(--text-secondary,#94a3b8)', fontSize: 13, textAlign: 'center' }}>
          Bir sipariş kartı seçtiğinizde kalemleri burada görünür.
        </div>
      </div>
    );
  }

  const lines = detail?.lines || [];

  return (
    <div style={wrap}>
      <Head
        title="Sipariş Detay"
        right={(
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <DocTypeChip value={order.documentType} onToggle={(v) => onDocTypeChange?.(order, v)} />
            <EDocBadge code={order.eDocumentType} />
          </div>
        )}
      />

      <div style={{ padding: '10px 14px', display: 'flex', gap: 18, flexWrap: 'wrap', borderBottom: '1px solid var(--border-color,#eef2f7)' }}>
        <Info label="Müşteri" value={order.customerName} strong />
        <Info label="Belge No" value={order.documentNo || '—'} />
        <Info label="Net Tutar" value={`${fmtMoney(detail?.netAmount ?? order.netAmount)} ₺`} />
        <Info label="KDV" value={`${fmtMoney(detail?.vatAmount ?? 0)} ₺`} />
        <Info label="Brüt" value={`${fmtMoney(detail?.grossAmount ?? order.grossAmount)} ₺`} />
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: 12 }}>
        {loading && <div style={{ color: 'var(--text-secondary,#94a3b8)', fontSize: 13, padding: 10 }}>Yükleniyor…</div>}
        {error && <div style={{ color: 'var(--danger)', fontSize: 13, padding: 10 }}>{error}</div>}
        {!loading && !error && (
          <div style={{ border: '1px solid var(--border-color,#e5e7eb)', borderRadius: 10, overflow: 'hidden' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '2.4fr 0.8fr 0.8fr 1fr 1fr', gap: 6, padding: '9px 12px', background: 'var(--grid-canvas,#f9fafb)', fontSize: 11, fontWeight: 800, textTransform: 'uppercase', color: 'var(--text-secondary,#6b7280)' }}>
              <div>Ürün</div>
              <div style={{ textAlign: 'right' }}>Miktar</div>
              <div>Birim</div>
              <div style={{ textAlign: 'right' }}>Net</div>
              <div style={{ textAlign: 'right' }}>Brüt</div>
            </div>
            {lines.length === 0 ? (
              <div style={{ padding: 14, color: 'var(--text-secondary,#94a3b8)', fontSize: 13 }}>Kalem bulunamadı.</div>
            ) : lines.map((ln, i) => (
              <div key={ln.orderDetailId || i} style={{ display: 'grid', gridTemplateColumns: '2.4fr 0.8fr 0.8fr 1fr 1fr', gap: 6, padding: '9px 12px', borderTop: '1px solid var(--border-color,#eef2f7)', fontSize: 13 }}>
                <div style={{ fontWeight: 600 }}>{ln.productName}</div>
                <div style={{ textAlign: 'right' }}>{fmtNumber(ln.quantity)}</div>
                <div style={{ color: 'var(--text-secondary,#64748b)' }}>{ln.unitName || '—'}</div>
                <div style={{ textAlign: 'right' }}>{fmtMoney(ln.netAmount)}</div>
                <div style={{ textAlign: 'right' }}>{fmtMoney(ln.grossAmount)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const wrap = {
  display: 'flex', flexDirection: 'column', minHeight: 0, height: '100%',
  background: 'var(--bg-card,#fff)', border: '1px solid var(--border-color,#e5e7eb)', borderRadius: 16, overflow: 'hidden',
};

function Head({ title, right }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 14px', borderBottom: '1px solid var(--border-color,#e5e7eb)' }}>
      <span aria-hidden="true" style={{ fontSize: 16 }}>📦</span>
      <span style={{ fontWeight: 800, fontSize: 14, color: 'var(--text-primary,#111827)' }}>{title}</span>
      {right && <span style={{ marginLeft: 'auto' }}>{right}</span>}
    </div>
  );
}

function Info({ label, value, strong }) {
  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-secondary,#94a3b8)' }}>{label}</div>
      <div style={{ fontSize: strong ? 14 : 13, fontWeight: strong ? 800 : 600, color: 'var(--text-primary,#111827)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 240 }}>{value}</div>
    </div>
  );
}
